import { alto } from '@parchment/atoms';
import React from 'react';
import styled from 'styled-components';
const ModalFooter = _ref => {
  let {
    footer,
    isInteractiveModal
  } = _ref;
  return footer && isInteractiveModal ? /*#__PURE__*/React.createElement(Footer, {
    className: "ui-modal-footer-wrapper",
    "data-testid": "modal-footer"
  }, footer) : null;
};
export default ModalFooter;
const Footer = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalFooter__Footer",
  componentId: "sc-1902imw-0"
})(["padding:10px 65px;display:flex;flex-wrap:wrap;gap:10px;justify-content:center;align-items:center;border-top:1px solid ", ";@media (min-width:769px){button{min-width:unset;max-width:50%;}}"], _ref2 => {
  let {
    theme
  } = _ref2;
  return (theme === null || theme === void 0 ? void 0 : theme.borderColor) || alto;
});